import { render, staticRenderFns } from "./DeleteItem.vue?vue&type=template&id=6fbd588e&scoped=true"
import script from "./DeleteItem.vue?vue&type=script&lang=js"
export * from "./DeleteItem.vue?vue&type=script&lang=js"
import style0 from "./DeleteItem.vue?vue&type=style&index=0&id=6fbd588e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbd588e",
  null
  
)

export default component.exports